var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-9"},[_c('div',{staticClass:"content-container fill-height"},[_c('v-responsive',{attrs:{"aspect-ratio":16 / 9}},[_c('v-skeleton-loader',{staticClass:"fill-height video-placeholder",attrs:{"type":"image"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }